import {PrivateImg} from '@/components/private-img'
import {useEffect, useState} from 'react'

export function PhotoTimelapse({
  photoId,
  frameCount,
  interval,
  ...props
}: React.ComponentProps<'div'> & {photoId: string; frameCount: number; interval: number}) {
  const [frame, setFrame] = useState<number>(0)
  const [isHovered, setIsHovered] = useState<boolean>(false)

  useEffect(() => {
    const ticker = setInterval(() => {
      if (isHovered) setFrame((frame + 1) % frameCount)
    }, interval)
    return () => clearInterval(ticker)
  })

  return (
    <PrivateImg
      src={`/api/photos/${photoId}/files/timelapse-${frame}.jpg`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    />
  )
}
